import React from 'react';
import { PillarPage } from '../components/PillarPage';
import { espirituPage } from '../data/pages/espiritu';
export function Espiritu() {
  return <PillarPage content={espirituPage} data-id="element-260" data-mp="20yw9zrup3uqj" />;
}